export default function () {
}



// WEBPACK FOOTER //
// ./src/app/professional/loading-page/gadget/resources/mounted.js